import React, { useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import {
  DcButton,
  DcInput,
  PixelAlert,
  PixelDate,
  PixelDiv,
  PixelDropDown,
  PixelFactoryContext,
  PixelFlexBox,
  PixelPageContainer,
  PixelTag,
  PixelText,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'
import styled, { keyframes } from 'styled-components'

import { get, makeCall, sendTestMessage } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'

const TestMessages = (props) => {
  const {
    planId,
    phone,
    email,
    getAllSmsConfig,
    isItOrder,
    data,
    setData,
    handleUpdate,
    setActiveTabs,
    SMSConfig,
    orderId = null,
    origin = 'setting',
  } = props
  const navigate = useNavigate()
  const availableBalance =
    SMSConfig.REMAINING_BALANCE || SMSConfig.REMAINING_CREDITS_FOR_PLAN
  const [error, setError] = useState({ error: '', field: '' })
  const [sentMessageDetail, setSentMessageDetail] = useState({
    id: '',
    credits_consumed: '',
    ems_customer_id: '',
    error: '',
    notification_type: '',
    plan_id: '',
    priority: '',
    processed_at: '',
    recipient: '',
    service_id: '',
    status: '',
    ack_status: '',
    text: '',
    message: '',
    customer_feedback: '',
    created_at: {
      date: '',
    },
  })
  const [messageSent, setMessageSent] = useState(false)
  const [message, setMessage] = useState({
    recipient: phone || '',
    text: '',
    plan_id: planId || '',
    carrier: 'Zong',
    subject: 'message',
    origin: isItOrder ? 'order' : 'setting',
    type: 'sms',
    order_id: orderId,
  })
  const [events, setEvents] = React.useState<any>([])
  React.useEffect(() => {
    setMessage({
      ...message,
      plan_id: planId,
    })
  }, [planId])
  const { showLoader, hideLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)
  const DetailSectionRef = React.useRef(null)
  const sendATestMessage = () => {
    showLoader(mainSectionRef)
    sendTestMessage(message).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response.error) {
        if (res.response.error.field) {
          setError({
            error: res.response.error.error,
            field: res.response.error.field,
          })
          showFailure(res.response.error.error)
        } else {
          setError({ error: res.response.error, field: '' })
          showFailure(res.response.error)
        }
      } else {
        setSentMessageDetail(res.response.data)
        showSuccess('Message queued successfully')
        if (isItOrder) {
          const recp = message.type === 'email' ? email : phone
          setMessage({
            ...message,
            recipient: recp,
          })
        } else {
          setMessage({ ...message, recipient: '', text: '' })
        }

        setError({ error: '', field: '' })
        getNotificationDetails(res.response.data.id)
        setMessageSent(true)
        if (isItOrder) {
          handleUpdate(res.response.data)
        } else {
          getAllSmsConfig()
        }
      }
    })
  }
  const getAllSmsEvents = () => {
    showLoader(mainSectionRef)
    get('/communication/events').subscribe((res: any) => {
      setEvents(res.response.data)
      hideLoader(mainSectionRef)
    })
  }
  const makeACall = () => {
    showLoader(mainSectionRef)
    const data = {
      recipient: message.recipient,
      plan_id: message.plan_id,
      carrier: message.carrier,
      origin: message.origin,
      order_id: orderId,
    }
    makeCall(data).subscribe((res: any) => {
      hideLoader(mainSectionRef)
      if (res.response.error) {
        if (res.response.error.field) {
          setError({
            error: res.response.error.error,
            field: res.response.error.field,
          })
          showFailure(res.response.error.error)
        } else {
          setError({ error: res.response.error, field: '' })
          showFailure(res.response.error)
        }
      } else {
        if (isItOrder) {
          const recp = message.type === 'email' ? email : phone
          setMessage({
            ...message,
            recipient: recp,
          })
        } else {
          setMessage({ ...message, recipient: '', text: '' })
        }
        showSuccess('Call Initiated Successfully')
        setMessageSent(true)
        setSentMessageDetail(res.response.data)
        getNotificationDetails(res.response.data.id)
        setError({ error: '', field: '' })
        if (isItOrder) {
          handleUpdate(res.response.data)
        } else {
          getAllSmsConfig()
        }
      }
    })
  }
  const handleSubmit = () => {
    if (message.type !== 'email') {
      if (
        !message.recipient.startsWith('92') &&
        !message.recipient.startsWith('923')
      ) {
        setError({
          error: 'Invalid Format, Format Should be 923xxxxxxxxx',
          field: 'recipient',
        })
        showFailure('Invalid Format')
        return
      } else if (message.recipient.length < 12) {
        setError({ error: 'Invalid phone number', field: 'recipient' })
        showFailure('Invalid phone number')
        return
      } else if (message.text.length < 1 && message.type !== 'call') {
        setError({ error: 'Message cannot be empty', field: 'text' })
        showFailure('Message cannot be empty')
        return
      }
    }
    if (message.type === 'call') {
      makeACall()
    } else {
      sendATestMessage()
    }
  }
  const carrierOptions = [
    { label: 'SMS', value: 'sms' },
    { label: 'Whatsapp', value: 'whatsapp' },
    { label: 'Email', value: 'email' },
    { label: 'Call', value: 'call' },
  ]

  const getNotificationDetails = (id) => {
    get(`/communication/queue/${id}`).subscribe((res: any) => {
      if (res.response.error) {
        if (res.response.error.field) {
          setError({
            error: res.response.error.error,
            field: res.response.error.field,
          })
          showFailure(res.response.error.error)
        } else {
          setError({ error: res.response.error, field: '' })
          showFailure(res.response.error)
        }
      } else {
        setSentMessageDetail(res.response.data)
      }
    })
  }
  React.useEffect(() => {
    if (!isItOrder) {
      let interval
      const status =
        message.type == 'call'
          ? ['received', 'rejected', 'delivered', 'failed', 'completed']
          : ['sent', 'failed']
      const status_type = message.type
        ? sentMessageDetail?.status
        : sentMessageDetail?.ack_status
      if (messageSent && !status.includes(status_type)) {
        interval = setInterval(() => {
          getNotificationDetails(sentMessageDetail?.id)
        }, 5000)
      }
      return () => {
        clearInterval(interval)
      }
    }
  }, [
    messageSent,
    sentMessageDetail.id,
    sentMessageDetail?.status,
    message,
    sentMessageDetail?.ack_status,
    isItOrder,
  ])

  React.useEffect(() => {
    if (isItOrder) {
      setData({
        ...data,
        comment: message.recipient + ' : ' + message.text,
      })
    }
  }, [message.text, message.recipient])

  React.useEffect(() => {
    getAllSmsEvents()
  }, [])
  React.useEffect(() => {
    if (isItOrder) {
      const recp = message.type === 'email' ? email : phone
      setMessage({
        ...message,
        recipient: recp,
      })
    }
  }, [message.type])

  return (
    <>
      <PixelFlexBox
        justifyContent="space-between"
        alignItems="flex-start"
        gap="10px"
        height="auto"
      >
        {availableBalance <= 0 ? (
          <PixelFlexBox
            margin="20px"
            gap="10px"
            flexDirection="column"
            height="auto"
          >
            <PixelText>
              Your credits balance is currently 0. To send SMS or make calls,
              please purchase credits first
            </PixelText>
            <PixelFlexBox width="100%" justifyContent="flex-end" height="auto">
              <DcButton
                onClick={() => {
                  if (origin == 'setting') {
                    setActiveTabs('balance')
                  } else {
                    navigate('/admin/sms')
                  }
                }}
              >
                Add Balance
              </DcButton>
            </PixelFlexBox>
          </PixelFlexBox>
        ) : (
          <>
            <PixelFlexBox>
              <form
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  padding: '10px',
                }}
                ref={mainSectionRef}
                onSubmit={handleSubmit}
              >
                {/* <PixelFlexBox
                  width="100%"
                  className="table-info-container"
                > */}
                <PixelFlexBox
                  flexDirection="row"
                  justifyContent="flex-end"
                  gap="10px"
                  style={{ width: isMobile ? '100%' : '80%' }}
                >
                  {message.type === 'sms' && (
                    <PixelAlert variant="danger">
                      <span>
                        There will be multiple credits used if characters exceed
                        above 160
                      </span>
                    </PixelAlert>
                  )}
                </PixelFlexBox>
                <PixelDiv>
                  <Messagetag>Send a Text Message</Messagetag>
                </PixelDiv>
                <PixelFlexBox
                  flexDirection="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  gap="10px"
                >
                  <PixelFlexBox
                    flexDirection="row"
                    justifyContent="flex-end"
                    gap="10px"
                    style={{ width: isMobile ? '100%' : '80%' }}
                  >
                    <PixelDropDown
                      value={message.type}
                      onChange={(e) => {
                        setMessage({
                          ...message,
                          type: e.target.value,
                          text: '',
                        })
                        setError({ error: '', field: '' })
                      }}
                      placeholder="Select Type"
                      required
                      options={carrierOptions}
                    />
                    <DcInput
                      required
                      error={
                        error.field === 'recipient' && error.error !== ''
                          ? error.error
                          : null
                      }
                      value={message.recipient}
                      onChange={(e) => {
                        setMessage({ ...message, recipient: e.target.value })
                      }}
                      type={message.type == 'email' ? 'email' : 'text'}
                      disabled={['whatsapp'].includes(message.type)}
                      placeholder={
                        message.type == 'email'
                          ? 'Recipient Email'
                          : 'Recipient Number'
                      }
                      maxLength={message.type == 'email' ? 320 : 13}
                    />
                  </PixelFlexBox>
                  {message.type === 'whatsapp' ? (
                    <>
                      <PixelFlexBox
                        flexDirection="row"
                        justifyContent="flex-end"
                        gap="10px"
                        style={{ width: isMobile ? '100%' : '80%' }}
                      >
                        <PixelDropDown
                          value={message.text}
                          onChange={(e) => {
                            setMessage({ ...message, text: e.target.value })
                          }}
                          placeholder="Select Template"
                          required
                          options={events.map((event) => ({
                            label: event.event_name,
                            value: event.event_code,
                          }))}
                        />
                      </PixelFlexBox>
                    </>
                  ) : (
                    (message.type === 'sms' || message.type === 'email') && (
                      <>
                        <PixelFlexBox
                          flexDirection="row"
                          justifyContent="flex-end"
                          gap="10px"
                          style={{ width: isMobile ? '100%' : '80%' }}
                        >
                          <PixelDiv
                            width="100%"
                            style={{ position: 'relative' }}
                          >
                            <DcInput
                              required={
                                message.type === 'email' ||
                                message.type === 'sms'
                                  ? true
                                  : false
                              }
                              error={
                                error.field === 'text' && error.error !== ''
                                  ? error.error
                                  : null
                              }
                              onChange={(e) => {
                                if (e.target.value.length > 320) {
                                  showFailure(
                                    'Message cannot be more than 320 characters',
                                  )
                                  return
                                }
                                setMessage({
                                  ...message,
                                  text: e.target.value,
                                })
                              }}
                              value={message.text}
                              placeholder={'Message'}
                              as={'textarea'}
                              // maxLength={320}
                            />
                            <PixelDiv
                              style={{
                                position: 'absolute',
                                right: '10px',
                                bottom: '10px',
                                fontSize: '14px',
                                color: 'gray',
                              }}
                              color={message.text.length > 160 ? 'red' : ''}
                            >
                              {message.text.length}/160
                            </PixelDiv>
                          </PixelDiv>
                        </PixelFlexBox>
                      </>
                    )
                  )}
                  {['whatsapp'].includes(message.type) ? (
                    <PixelPageContainer>
                      <PixelText>Coming Soon...</PixelText>
                    </PixelPageContainer>
                  ) : (
                    <PixelFlexBox
                      flexDirection="row"
                      justifyContent="flex-end"
                      gap="10px"
                      style={{ width: isMobile ? '100%' : '80%' }}
                    >
                      <DcButton onClick={() => handleSubmit()}>Send</DcButton>
                    </PixelFlexBox>
                  )}
                </PixelFlexBox>
                {/* </PixelFlexBox> */}
              </form>
            </PixelFlexBox>
          </>
        )}

        {!isItOrder && (
          <Section ref={DetailSectionRef}>
            {messageSent && (
              <>
                <PixelFlexBox
                  flexDirection="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  gap="10px"
                >
                  <SectionTitle>Notification Status</SectionTitle>
                  <CircleWrapper>
                    <PixelDiv
                      style={{
                        content: '',
                        display: 'block',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        backgroundColor: '#ededed',
                        zIndex: '-1',
                        opacity: '0.3',
                      }}
                    />
                  </CircleWrapper>
                </PixelFlexBox>
                <SectionContent>
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Status:
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      <PixelTag
                        customBackgroundColor={
                          sentMessageDetail?.status === 'sent'
                            ? 'green'
                            : sentMessageDetail?.status === 'failed'
                            ? '#f44336'
                            : sentMessageDetail?.status === 'queued'
                            ? '#ffc107'
                            : '#cc01fa'
                        }
                      >
                        {sentMessageDetail?.status}
                      </PixelTag>
                    </PixelDiv>
                  </PixelDiv>
                  {message.type === 'call' && (
                    <PixelDiv
                      style={{
                        display: 'table',
                        tableLayout: 'fixed',
                        borderSpacing: '0',
                        borderCollapse: 'collapse',
                        width: '100%',
                      }}
                    >
                      <PixelDiv
                        padding="10px"
                        backgroundColor="#e9ecef"
                        width="40%"
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        Acknowledge Status:
                      </PixelDiv>
                      <PixelDiv
                        padding="0 0 0 10px"
                        width="60%"
                        backgroundColor="#e9ecef78"
                        style={{
                          fontSize: '16px',
                          fontWeight: '500',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                          color: '#000',
                        }}
                      >
                        {(
                          <PixelTag
                            customBackgroundColor={
                              sentMessageDetail?.ack_status === 'sent'
                                ? 'green'
                                : sentMessageDetail?.ack_status === 'failed'
                                ? '#f44336'
                                : sentMessageDetail?.ack_status === 'queued'
                                ? '#ffc107'
                                : '#cc01fa'
                            }
                          >
                            {sentMessageDetail?.ack_status}
                          </PixelTag>
                        ) || '--'}
                      </PixelDiv>
                    </PixelDiv>
                  )}
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Recipient:
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      {sentMessageDetail?.recipient}
                    </PixelDiv>
                  </PixelDiv>
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Message:
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      {sentMessageDetail?.text
                        ? sentMessageDetail?.text
                        : sentMessageDetail?.message}
                    </PixelDiv>
                  </PixelDiv>
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Priority:
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      {sentMessageDetail?.priority}
                    </PixelDiv>
                  </PixelDiv>
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Sent At:
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      <PixelDate
                        format="pixelStandard"
                        value={sentMessageDetail?.created_at.date}
                      />
                    </PixelDiv>
                  </PixelDiv>
                  <PixelDiv
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                      width: '100%',
                    }}
                  >
                    <PixelDiv
                      padding="10px"
                      backgroundColor="#e9ecef"
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      Credits Consumed
                    </PixelDiv>
                    <PixelDiv
                      padding="0 0 0 10px"
                      width="60%"
                      backgroundColor="#e9ecef78"
                      style={{
                        fontSize: '16px',
                        fontWeight: '500',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        color: '#000',
                      }}
                    >
                      {sentMessageDetail?.credits_consumed}
                    </PixelDiv>
                  </PixelDiv>
                  {message.type == 'call' && (
                    <PixelDiv
                      style={{
                        display: 'table',
                        tableLayout: 'fixed',
                        borderSpacing: '0',
                        borderCollapse: 'collapse',
                        width: '100%',
                      }}
                    >
                      <PixelDiv
                        padding="10px"
                        backgroundColor="#e9ecef"
                        width="40%"
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        Customer Feedback
                      </PixelDiv>
                      <PixelDiv
                        padding="0 0 0 10px"
                        width="60%"
                        backgroundColor="#e9ecef78"
                        style={{
                          fontSize: '16px',
                          fontWeight: '500',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                          color: '#000',
                        }}
                      >
                        {sentMessageDetail?.customer_feedback}
                      </PixelDiv>
                    </PixelDiv>
                  )}
                </SectionContent>
              </>
            )}
          </Section>
        )}
      </PixelFlexBox>
    </>
  )
}

const Messagetag = styled.span`
  font-size: 14px;
  font-weight: 500;
`

const changeColor = keyframes`
  0% {
    background-color: #25d366;
  }
  50% {
    background-color: #EDEDED;
  }
  100% {
    background-color: #25D366;
  }
`

const CircleWrapper = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #25d366;
  position: relative;
  animation-name: ${changeColor};
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`

export default TestMessages
